import type { CSSProperties, ReactNode } from 'react'

/*
  DataTable — tabla estándar. Envuelve `.table-container` + <table> (los estilos
  globales de thead/tbody de index.css hacen el resto). Definís columnas y filas;
  cada columna puede tener un `render` para celdas custom (badges, botones…).
*/
export interface Column<T> {
  key: string
  header: ReactNode
  render?: (row: T, index: number) => ReactNode
  align?: 'left' | 'right' | 'center'
  width?: number | string
}

interface DataTableProps<T> {
  columns: Column<T>[]
  rows: T[]
  rowKey: (row: T, index: number) => string | number
  loading?: boolean
  empty?: ReactNode
  onRowClick?: (row: T) => void
}

export function DataTable<T>({ columns, rows, rowKey, loading, empty, onRowClick }: DataTableProps<T>) {
  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key} style={{ textAlign: c.align ?? 'left', width: c.width }}>{c.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={columns.length} style={centerCell('var(--text-secondary)')}>Cargando…</td></tr>
          ) : rows.length === 0 ? (
            <tr><td colSpan={columns.length} style={centerCell('var(--text-muted)')}>{empty ?? 'Sin registros.'}</td></tr>
          ) : (
            rows.map((row, i) => (
              <tr
                key={rowKey(row, i)}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                style={onRowClick ? { cursor: 'pointer' } : undefined}
              >
                {columns.map((c) => (
                  <td key={c.key} style={{ textAlign: c.align ?? 'left' }}>
                    {c.render ? c.render(row, i) : (row as Record<string, ReactNode>)[c.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}

function centerCell(color: string): CSSProperties {
  return { textAlign: 'center', color, padding: '32px 16px' }
}
